import { ui } from '@owenscorning/pcb.alpha';
import Article from './Article';

const Fleetwood = Article(
  'Article::Fleetwood',
  'fleetwood_blog',
  [
    'SocialMediaShareBanner',
    'RelatedArticles',
  ],
  ui`AttributeSet`({
    query: {
      name: 'Article Attributes',
      path: '/blog',
    },
  }),
  {
    version: '0.1',
    displayName: 'Fleetwood Blog Article',
    paths: ['blog'],
  }
)

export default Fleetwood;
